export default __webpack_public_path__ + "static/stative-compound-intransitive-5b0d7f49587b61096c6276b6d00990db.svg";